<template>
  <div>
    <div class="version_box">
      <div class="version_item">
        <div class="version_img" :class="{version_img_bd:version == 1}" @click="changeVersion(1)">
          <img src="@/assets/images/duty_1.png" style="width:100%" alt="">
        </div>
        <div class="version_radio">
          <el-radio v-model="version" :label="1">旧版交班
            <el-button type="text" style="margin-left: 30px" @click="showImg(1)">查看大图</el-button>
          </el-radio>
        </div>
      </div>
      <div class="version_item">
        <div class="version_img" :class="{version_img_bd:version == 2}" @click="changeVersion(2)">
          <img src="@/assets/images/duty_2.png" style="width:100%" alt="">
        </div>
        <div class="version_radio">
          <el-radio v-model="version" :label="2">新版交班
            <el-button type="text" style="margin-left: 30px" @click="showImg(2)">查看大图</el-button>
          </el-radio>
        </div>
      </div>
    </div>
    <div class="version_button">
      <el-button @click="saveVersion()" type="primary">确定</el-button>
      <el-checkbox v-model="saveSelect" border style="margin-left:20px">记住选择</el-checkbox>
    </div>
    <el-dialog :visible.sync="showLarge" :title="largeTitle" width="800px" append-to-body>
      <img v-if="showLargeImg==1" style="width:100%" src="@/assets/images/duty1.png" alt="">
      <img v-if="showLargeImg==2" style="width:100%" src="@/assets/images/duty2.png" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      version: 1,
      saveSelect: true,
      showLarge: false, // 查看大图
      showLargeImg: 1, // 大图版本
      largeTitle: "旧版交班"
    }
  },
  mounted(){

  },
  methods:{
    changeVersion(i){
      this.version = i;
    },
    saveVersion(){
      this.$emit('saveVersion',this.version,this.saveSelect)
    },
    showImg(i){
      this.showLargeImg = i;
      this.largeTitle = i == 1? "旧版交班":"新版交班";
      this.showLarge = true;
    }
  },
}
</script>

<style lang="scss" scoped>
.version_box{
  margin: -20px 20px -10px 20px;
  display: flex;
  .version_item{
    margin: 0 20px;
    flex: 1;
    text-align: center;
    .version_img{
      border: 1px solid #eee;
      border-radius: 10px;
      padding: 3px;
    }
    .version_radio{
      margin-top: 5px;
    }
    .version_img_bd{
      border: 2px solid #409eff;
    }
  }
}
.version_button{
  margin-top: 20px;
  text-align: center;
}
</style>